<div class="simple-date-picker">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="simple-date-field filter-date-field-no-outline">
    <input
      matInput
      [matDatepicker]="picker"
      [(ngModel)]="value"
      (ngModelChange)="onDateChange($event)"
      placeholder="MM/DD/YYYY"
      readonly
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker panelClass="filter-simple-datepicker-panel"></mat-datepicker>
  </mat-form-field>
</div>
